import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaSpecialtyCreate = yup.object().shape({
  description: yup
    .string()
    .required(translate('specialtiesModal.validation.descriptionRequired')),
});

export const schemaSpecialtyEdit = yup.object().shape({
  description: yup
    .string()
    .required(translate('specialtiesModal.validation.descriptionRequired')),
  status: yup
    .boolean()
    .required(translate('specialtiesModal.validation.statusRequired')),
});
